inputs-complex-comment-textarea
  .row
    .col-auto
      .user
        span { opts.user_name }
        i.feather.icon-user.bg-c-green
    .col
      .msg-wrap
        .msg
          textarea(class="form-control { opts.klass }" name="{ opts.name }" placeholder="{ opts.placeholder }" type="text" onInput="{this.onInput}" onChange="{this.onChange}" rows="{opts.rows}") { opts.value }
          div.help-block(if="{ opts.errors }")
            ul(role="alert")
              li.text-danger.error(each="{message in opts.errors}") { message }
        .btn-wrap
          button.btn.btn-md.btn-success
            | { opts.button_label }
  script(type="typescript").
    this.mixin('inputs.textarea');
  style(scoped).
    .msg:after {
      content: "";
      position: absolute;
      left: -7px;
      top: -7px;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
      border: 7px solid transparent;
      border-bottom-color: rgba(68,138,255,0.1);
    }
    .msg {
      display: block;
      padding: 10px;
      position: relative;
      background: rgba(68,138,255,0.1);
      border-radius: 0 5px 5px 5px;
      flex-grow: 1;
    }
    textarea.form-control {
      background: rgba(68,138,255,0.1);
      border-radius: 0 5px 5px 5px;
      border-width: 0;
    }
    .col-auto {
      min-width: 180px;
    }
    .user {
      text-align: right;
    }
    .icon-user {
      width: 40px;
      height: 40px;
      font-size: 16px;
      padding: 12px 13px;
      margin-left: 10px;
      border-radius: 50%;
      text-align: center;
      color: #fff;
    }
    .msg-wrap {
      display: flex;
    }
    .btn-wrap {
      align-self: flex-end;
      padding-left: 10px;
    }
